import axios from 'axios';

const getSettings = () => axios.get(`/global-pay`);

const updateSettings = params => axios.put(`/global-pay`, params);

export { getSettings, updateSettings };
